import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const ApprovalElement = (props) => {
  return (
    <div className="signature-element approved">
      <div className="signed">
        <div className="signed-text">Approved</div>
      </div>
      <div>
        <b>{props.approvedOneBy}</b> {moment(props.approvedOneAt).format('HH:mm on MMM D, YYYY')}
        {props.approveCommentOne && <div><b>Notes:</b> {props.approveCommentOne}</div>}
      </div>
    </div>
  );
};

export default ApprovalElement;
